"use client";
import React from "react";
import Tax1 from "../Images/download__9_-removebg-preview.png";

function TaxServices() {
  return (
    <section className="tax-modern">
      <div className="container">

        {/* HEADING */}
        <h2 className="main-heading">
          <span>Our Tax Services</span>
        </h2>

        <div className="row align-items-center">

          {/* LEFT SIDE */}
          <div className="col-lg-4">
            <div className="service-card">
              <h4>Individual Tax Services</h4>
              <p>
                From tax planning to filing, we assist individuals in optimizing their tax positions, ensuring compliance with the latest tax laws.
              </p>
            </div>

            <div className="service-card mt-4">
              <h4>Tax Consulting</h4>
              <p>
                Leverage our expertise for strategic tax advice, specialized consulting, and navigating complex tax issues with confidence.
              </p>
            </div>
          </div>

          {/* CENTER */}
          <div className="col-lg-4 text-center">
            <div className="center-card">
              <img src={Tax1} alt="" className="center-img" />
              <h3>Accounting Services</h3>
              <p>
                Our suite of services is designed to cater to businesses of all sizes and industries. Whether you're a startup, a small business, or a large corporation, we offer a range of Accounting services tailored to meet your specific needs. From bookkeeping and payroll processing to tax planning and financial analysis, we are your one-stop solution for all.
              </p>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-4">
            <div className="service-card">
              <h4>Business Tax Services</h4>
              <p>
                Our comprehensive business tax solutions cover everything from strategic tax planning to compliance, helping businesses minimize tax liabilities and enhance profitability.
              </p>
            </div>

            <div className="service-card mt-4">
              <h4>Tax Representation</h4>
              <p>
                Cases where representation is required before various authorities including but not limited to Income Tax Department and GST Trademark, RERA, FSSAI, DGFT our experienced team stands by your side, providing steadfast representation to protect your interests.
              </p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .tax-modern {
          padding: 90px 0;
          background: linear-gradient(135deg, #f8fbff, #eef5ff);
        }

        .main-title {
          font-size: 36px;
          font-weight: 800;
          color: #0f172a;
        }

        /* SIDE CARDS */
        .service-card {
          background: #fff;
          padding: 28px;
          border-radius: 18px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.06);
          transition: all 0.3s ease;
          border: 1px solid #eef2f7;
        }

        .service-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 18px 45px rgba(0,0,0,0.1);
        }

        .service-card h4 {
          color: #115886;
          font-weight: 700;
          margin-bottom: 10px;
        }

        .service-card p {
          color: #6b7280;
          margin-bottom: 0;
        }

        /* CENTER CARD */
        .center-card {
          background: linear-gradient(135deg, #115886, #1e88e5);
          padding: 40px 30px;
          border-radius: 22px;
          color: white;
          box-shadow: 0 20px 60px rgba(17,88,134,0.35);
          transform: scale(1.05);
        }

        .center-img {
          width: 70px;
          margin-bottom: 15px;
        }

        .center-card h3 {
          font-weight: 700;
          margin-bottom: 12px;
        }

        .center-card p {
          color: #eaf4ff;
        }

        /* RESPONSIVE */
        @media (max-width: 992px) {
          .center-card {
            margin: 30px 0;
            transform: none;
          }
        }

        @media (max-width: 768px) {
          .main-title {
            font-size: 26px;
          }
        }

      `}</style>
    </section>
  );
}

export default TaxServices;